import { Component, Input } from '@angular/core';
import { Merchant, MerchantMenu } from "../../../../../common/interfaces/Merchant";

@Component({
  selector: 'list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss']
})
export class ListMenuComponent {
  @Input() merchant: Merchant | null = null;

  getList(): MerchantMenu[] {
    return this.merchant?.menuItems ?? []
  }

  getImageSrc(item: MerchantMenu): string {
    let url = item.url
    if (this.isPDF(url)) {
      url = "assets/file-pdf.svg"
    }
    return url
  }

  isPDF(url: string) {
    return url.includes('.pdf')
  }

  openURLInNewTab(item: MerchantMenu): void {
    let url = item.url
    window.open(url as string, '_blank');
  }
}

